//    underi18n v1.1.0

//    (c) 2012-2015 Yiorgis Gozadinos
//    underi18n is distributed under the MIT license.
//    http://github.com/ggozad/underi18n

/**
 * Modifications list for Inbooma:
 * 
 * Added "transform" param to this.translate()
 * Changed replacer from "$" to "%"
 * String transformers
 * Client & branch specific translations
 */

import Cookies from '../js/utils/Biscuit';

export default {

    MessageFactory: (function () {
        
        var MessageFactory = function (catalog) {

            this.translate = function (msgid, keywords, transformers) {
                
                let msgstr = null;

                if (catalog[msgid]) {
                    // @todo Get branch-specific string 
                    if (catalog['C_' + Cookies.get('user.client_id') + '_' + msgid]) {
                        // Get client-specific string
                        msgstr = catalog['C_' + Cookies.get('user.client_id') + '_' + msgid];
                    } else {
                        msgstr = catalog[msgid];
                    }
                } else {
                    msgstr = msgid;
                    // console.log('Failed to translate', msgstr);
                }
                if (keywords) {
                    for (var key in keywords) {
                        msgstr = msgstr.replace('${'+key+'}', keywords[key]);
                    }
                }
                if (transformers) {
                    
                    transformers.split('|||').forEach(function(transform) {

                        switch (transform) {
                            case 'capital' :
                            // First char upper case
                            msgstr = msgstr.charAt(0).toUpperCase() + msgstr.slice(1);
                            break;

                            case 'lower' :
                            // First char lower case
                            msgstr = msgstr.charAt(0).toLowerCase() + msgstr.slice(1);
                            break;

                            case 'plural' : 
                            // @TODO, lang-dependent
                            msgstr = msgstr //+ 's';
                            break;
                        }

                    });
                }
                return msgstr;
            };
        };
        return function (catalog) {
            return new MessageFactory(catalog).translate;
        };
    })(),

    template: function (str, factory) {
        var s = this.templateSettings;
        return str.replace(s.translate, function (match, code) {
            return factory(
                code
                .replace(/^\s+|\s+$/g, '')
            );
        }).replace(/\$\{(.*?)\}/g, function (m, c) {                console.log('trans', m,c);
        return s.i18nVarLeftDel + c + s.i18nVarRightDel;
        });
    },

    templateSettings: {
        translate: /<%_([\s\S]+?)%>/g,
        i18nVarLeftDel: '<%=',
        i18nVarRightDel: '%>'
    }
};


